var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dea-error"},[(_vm.isIconVisible)?_c('i',{staticClass:"dea-ico-error"}):_vm._e(),_vm._v(" "),_c('p',{staticClass:"dea-heading--medium__xs dea-error__text"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }